'use client'

import Button from "@/components/button/Button"
import { showInlineContactForm } from "@/utils/Helpers"
import { strings } from "@/utils/I18n"

export default function ShowLeadFormButton(props) {

  const label = props.label || strings(props.site)[props.labelKey]

  return <Button onClick={e => showInlineContactForm(props.params)} theme="secondary" label={ label }>{ label }</Button>

}